<div class="spinner" *ngIf="isLoading$ | async">
  <mat-spinner class="default-layout__spinner"></mat-spinner>
</div>

<ng-container [ngSwitch]="viewState$ | async">
  <section class="frodo" *ngSwitchCase="'ready'">
    <nav class="frodo__left-menu">
      <frodo-left-menu></frodo-left-menu>
    </nav>
    <main class="frodo__right-content">
      <router-outlet></router-outlet>
    </main>
  </section>

  <frodo-system-upgrade *ngSwitchCase="'upgrading'"></frodo-system-upgrade>

  <frodo-system-ready *ngSwitchDefault></frodo-system-ready>
</ng-container>
